import React from 'react';
import { useNavigate } from 'react-router-dom';
import image1 from '../assets/enrobé.jpeg';
import image2 from '../assets/pave.jpeg';
import image3 from '../assets/homme-aide-pelle-.jpg';
import '../RealisationCard.css';

const RealisationCard = () => {
  const navigate = useNavigate();

  const projets = [
    {
      imageSrc: image1,
      title: "Engagement et Fiabilité",
      description: "Nos collaborateurs sont au cœur de notre réussite. Grâce à leur professionnalisme, nous garantissons le respect des délais et des attentes de nos clients.",
      id: "collaborateurs",
    },
    {
      imageSrc: image2,
      title: "Sécurité",
      description: "La sécurité est une de nos priorités majeures. En plus des protocoles de sécurité stricts, nous nous engageons à minimiser l'impact écologique de nos travaux.",
      id: "securite",
    },
    {
      imageSrc: image3,
      title: "Respect de l'Environnement",
      description: "Nous nous engageons à minimiser l'impact de nos travaux sur l'environnement. En adoptant des pratiques durables et des technologies écologiques.",
      id: "environnement",
    },
  ];

  // Fonction pour naviguer et scroller
  const handleNavigation = (id) => {
    navigate(`/nos-valeurs#${id}`); // Redirige vers la page NosValeurs avec une ancre
  };

  return (
    <div className="valeur-section">
      <div className="values-section">
        <h2 className="values-title">Nos valeurs</h2>
        <div className="separator-line"></div>
        <p className="values-description">
        Nos valeurs sont le fondement de notre approche et de notre réussite.
        Elles guident nos actions et garantissent que chaque projet respecte nos standards élevés de qualité,
        de sécurité et de durabilité. Découvrez nos engagements et ce qui fait notre différence.        </p>
      </div>
      
      <div className="valeur-container">
        {projets.map((projet, index) => (
          <div key={index} className="realisation-card">
            <div className="image-container">
              <img src={projet.imageSrc} alt={projet.title} className="main-image" />
              <div className="overlay-card">
                <h3>{projet.title}</h3>
                <p>{projet.description}</p>
                <button className="en-savoir-plus" onClick={() => handleNavigation(projet.id)}>
                  En savoir plus
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RealisationCard;
